import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "../store";
import PrintJs from "print-js";
import axios from "axios";

class StatisticsService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    // --- NEW FUNCTIONS START ---

    getGlobalUnits() {
        return Vue.axios.get(`${API_HOST}/api/GlobalUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    getRegions() {
        return Vue.axios.get(`${API_HOST}/api/region`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    getContractStatistics({ globalUnitId, regionId, start, end }) {
        return Vue.axios.get(`${API_HOST}/api/OrganizationContractReport`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                globalUnitId: globalUnitId ? globalUnitId : null,
                regionId: regionId ? regionId : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    // --- NEW FUNCTIONS END ---

    getRegionStatistics({inn, unitId, globalunitId, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/RegionStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                unitId: unitId ? unitId : null,
                globalunitId: globalunitId ? globalunitId : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getAreaStatistics({regionId, inn, unitId, globalunitId, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/AreaStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                regionId: regionId,
                inn: inn ? inn : null,
                unitId: unitId ? unitId : null,
                globalunitId: globalunitId ? globalunitId : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getOrganizationStatistics({ unit, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/OrganizationStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                unit: unit ? unit : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getUnitStatistics({ inn , start, end}) {
        return Vue.axios.get(`${API_HOST}/api/UnitStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getClientUnitStatistics({clientId, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/ClientUnitStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getClientStatistics({clientId, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/ClientStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getClientAreaStatistics({regionId, clientId, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/ClientAreaStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                regionId: regionId,
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    printRegionStatistics({inn, unitId, globalunitId, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/RegionStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                unitId: unitId ? unitId : null,
                globalunitId: globalunitId ? globalunitId : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printAreaStatistics({regionId, inn, unitId, globalunitId, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/AreaStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                regionId: regionId,
                inn: inn ? inn : null,
                unitId: unitId ? unitId : null,
                globalunitId: globalunitId ? globalunitId : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printOrganizationStatistics({inn ,  unit, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/OrganizationStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                unit: unit ? unit: null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printUnitStatistics({inn, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/UnitStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printClientUnitStatistics({clientId, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/ClientUnitStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printClientStatistics({clientId, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/ClientStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    printClientAreaStatistics({clientId, start, end, isPdf, regionId}) {
        const promise = Vue.axios.get(`${API_HOST}/api/ClientAreaStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                regionId: regionId,
                client: clientId,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }

    getUnitStatisticsByUser({inn, start, end}) {
        return Vue.axios.get(`${API_HOST}/api/UnitStatistics`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    printUnitStatisticsByUser({inn, start, end, isPdf}) {
        const promise = Vue.axios.get(`${API_HOST}/api/UnitStatistics`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn ? inn : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                isPdf: isPdf
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            PrintJs(url);
        });

        return promise;
    }
}

export default new StatisticsService()